import { sb } from '../supabase.ts';
import { escapeHtml } from '../main.ts';

export async function renderTeacherPage(app: HTMLElement): Promise<void> {
  app.innerHTML = `
    <div class="container" style="max-width: 100%; padding: 1rem;">
      <div class="page-header" style="display:flex; justify-content:space-between; align-items:center;">
        <h1>Teacher Database</h1>
        <a href="/" class="btn outline">Back</a>
      </div>
      <div class="card responsive" style="padding: 0; overflow-x: hidden;">
        <table class="modern-table compact">
          <thead>
            <tr>
              <th>SL</th><th>IID</th><th>PHOTO</th><th>NAME (EN)</th><th>SECTOR</th><th>DESIGNATION</th><th>PHONE</th><th>EMAIL</th><th>NID</th><th>JOIN DATE</th><th>ACTION</th>
            </tr>
          </thead>
          <tbody id="teacherTable">
            <tr><td colspan="11">Loading...</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="photo-preview" style="position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); background:#fff; border:2px solid #ddd; border-radius:8px; padding:12px; box-shadow:0 10px 40px rgba(0,0,0,0.35); z-index:10001; display:none; pointer-events:none;">
      <img src="" alt="preview" style="max-width:500px; max-height:600px; object-fit:contain;"/>
    </div>
  `;

  const tbody = document.getElementById('teacherTable')!;
  const { data, error } = await sb.from('teacher_database').select('*').order('iid', { ascending: true });

  if (error) {
    tbody.innerHTML = `<tr><td colspan="11">Error: ${error.message}</td></tr>`;
    return;
  }

  tbody.innerHTML = (data || []).map((t, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${t.iid}</td>
      <td><img src="${t.pp_photo || 'https://via.placeholder.com/40x50?text=No+Photo'}" class="row-thumb hover-preview" style="width:40px; height:50px; object-fit:cover; border-radius:4px; border:1px solid #eee; cursor:pointer;"></td>
      <td>${escapeHtml(t.teacher_name_en)}</td>
      <td>${escapeHtml(t.sector || '—')}</td>
      <td>${escapeHtml(t.designation_en)}</td>
      <td>${t.mobile_number_en}</td>
      <td>${escapeHtml(t.teacher_email_id || '—')}</td>
      <td>${escapeHtml(t.nid_number_en || '—')}</td>
      <td>${escapeHtml(t.join_date || '—')}</td>
      <td>
        <a href="/teacher_edit?iid=${t.iid}&mode=view" class="btn small" style="text-decoration:none; display:inline-block; margin-right:5px;">View</a>
        <a href="/teacher_edit?iid=${t.iid}&mode=edit" class="btn small edit" style="text-decoration:none; display:inline-block; background:#ff6b35; border-color:#ff6b35;">Edit</a>
      </td>
    </tr>
  `).join('') || '<tr><td colspan="11">No teachers found</td></tr>';

  // Setup Hover Preview
  const previewEl = document.getElementById('photo-preview')!;
  const previewImg = previewEl.querySelector('img')!;
  document.querySelectorAll('.hover-preview').forEach((el: any) => {
    el.addEventListener('mouseenter', (e: any) => {
      previewImg.src = e.target.src;
      previewEl.style.display = 'block';
    });
    el.addEventListener('mouseleave', () => {
      previewEl.style.display = 'none';
    });
  });
}
